import React, { useEffect } from "react";
import styled from "styled-components";
import Header from "@/components/main/Header";
import Footer from "@/components/main/Footer";
import ProductItem from "@/components/products/ProductItem";
import { IProductType } from "@/typings/Props";
import useProduct from "@/hooks/useProduct";
import { useTranslation } from "react-i18next";

const ProductsWrapper = styled.div`
  padding: 40px 0px;
  margin: 0 auto;
  max-width: 1200px;
`;
const Title = styled.p`
  text-align: center;
  font-size: 2.8rem;
  font-weight: 700;
  color: #971b2f;
  padding: 50px;
`;

const ProductItemsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-grow: 1;
  margin: auto;
  gap: 16px; //

  a[href^="/product/"] {
    width: calc(25% - 20px);
  }

  @media (max-width: 1000px) {
    a[href^="/product/"] {
      width: calc(50% - 20px);
    }
  }
`;

export default function AllProducts() {
  const product = useProduct();
  const { t } = useTranslation();

  useEffect(() => {
    product.fetchProductsAsync();
  }, []);

  return (
    <>
      <Header />
      <ProductsWrapper>
        <Title>{t("menu.products")}</Title>
        <ProductItemsWrapper>
          {product.state.products.map((data: IProductType) => {
            return <ProductItem {...data} key={data.id} />;
          })}
        </ProductItemsWrapper>
      </ProductsWrapper>
      <Footer />
    </>
  );
}
